import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MasajidContext } from "../contexts/MasajidContext";
import { Heart, Trash2 } from "lucide-react";

function Favourites() {
  const { getFavourites, removeFavourite, language } =
    useContext(MasajidContext);
  const navigate = useNavigate();
  const favouriteMasajid = getFavourites();

  const handleViewDetails = (masjid) => {
    navigate(`/masjid/${masjid.username}`);
  };

  const handleRemoveFavourite = (e, username) => {
    e.stopPropagation(); // Prevent triggering the card click
    removeFavourite(username);
  };

  return (
    <>
      <div
        style={{
          color: "#ffffff",
          marginTop: 16,
        }}
      >
        <h3 className="card-title" style={{ textAlign: "center" }}>
          {language === "urdu" ? "پسندیدہ مساجد" : "Favourite Masajid"}
        </h3>
      </div>

      {favouriteMasajid.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 40,
            padding: "20px",
          }}
        >
          <Heart
            size={64}
            color="rgb(27, 179, 200)"
            strokeWidth={1.5}
            style={{ marginBottom: 20, opacity: 0.5 }}
          />
          <p
            style={{
              textAlign: "center",
              color: "rgb(255, 255, 255, 0.8)",
              fontSize: "1.1rem",
              marginBottom: 10,
            }}
            lang={language === "urdu" && "ur"}
          >
            {language === "urdu"
              ? "ابھی تک کوئی پسندیدہ مسجد نہیں"
              : " No favourite Masajid yet"}
          </p>
          <p
            style={{
              textAlign: "center",
              color: "rgb(255, 255, 255, 0.6)",
              fontSize: "0.9rem",
              maxWidth: "600px",
            }}
            lang={language === "urdu" && "ur"}
          >
            {language === "urdu"
              ? "مساجد کو یہاں دیکھنے کے لیے ان کے تفصیلی صفحات سے اپنے پسندیدہ میں شامل کریں"
              : "Add Masajid to your favourites from their detail pages to see them here"}
          </p>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <p
            style={{
              textAlign: "center",
              color: "rgb(255, 255, 255, 0.6)",
              fontSize: "0.9rem",
              marginBottom: 18,
            }}
            dir={language === "urdu" ? "rtl" : "ltr"}
            lang={language === "urdu" && "ur"}
          >
            {language === "urdu"
              ? `${favouriteMasajid.length}  ${favouriteMasajid.length === 1 ? "مسجد" : "مساجد"}`
              : `${favouriteMasajid.length} ${favouriteMasajid.length === 1 ? "Masjid" : "Masajid"} saved`}
          </p>

          {favouriteMasajid.map((masjid, index) => (
            <div
              key={masjid.username}
              className="d-flex justify-content-center fade-in"
              onClick={() => handleViewDetails(masjid)}
              style={{
                animationDelay: `${index * 50}ms`,
                background: "radial-gradient(circle, #0a3545, #041b23)",
                borderRadius: "12px",
                padding: "12px",
                marginTop: "10px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                border: "3px solid rgb(27, 179, 200, 0.3)",
                width: "95%",
                maxWidth: "800px",
              }}
            >
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: language === "urdu" ? "row-reverse" : "row",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      textAlign: language === "urdu" ? "right" : "left",
                      minWidth: 0,
                    }}
                  >
                    <h6
                      style={{
                        margin: "0 0 4px 0",
                        color: "#ffffff",
                        fontSize: "1rem",
                        textAlign: language === "urdu" ? "right" : "left",
                      }}
                      lang={language === "urdu" && "ur"}
                    >
                      {language === "urdu" ? masjid.urdName : masjid.engName}
                    </h6>
                  </div>
                  <div
                    onClick={(e) => handleRemoveFavourite(e, masjid.username)}
                    style={{
                      marginLeft: language === "urdu" ? "0" : "10px",
                      marginRight: language === "urdu" ? "10px" : "0",
                      flexShrink: 0,
                      cursor: "pointer",
                      padding: "4px",
                      borderRadius: "50%",
                      transition: "background-color 0.2s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(230, 57, 70, 0.2)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <Trash2 size={24} color="#e63946" strokeWidth={2} />
                  </div>
                </div>
                <p
                  style={{
                    marginBottom: 12,
                    color: "rgb(255, 255, 255, 0.6)",
                    fontSize: "0.8rem",
                    textAlign: language === "urdu" ? "right" : "left",
                    maxWidth: "73%",
                    marginLeft: language === "urdu" ? "auto" : "0",
                  }}
                  lang={language === "urdu" && "ur"}
                  dir={language === "urdu" ? "rtl" : "ltr"}
                >
                  {language === "urdu" ? masjid.addressUrdu : masjid.address}
                </p>
                <p
                  style={{
                    fontSize: "0.8rem",
                    marginBottom: 0,
                    color: "rgb(7,240,255)",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                  lang={language === "urdu" && "ur"}
                >
                  {language === "urdu"
                    ? "تفصیلات دیکھنے کے لیے یہاں دبائیں"
                    : "Click to view details"}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default Favourites;
